import { deepEquals } from "rcd-cpp-workspace/utils/deepEquals";
import { FieldType } from "../enums/FieldType";
import { Metadata, Schema, SchemaField } from "../types/Metadata";

export const getRefIdSorted = (m: Metadata[]) => {
  if (!m) return m;
  if (!Array.isArray(m)) return [(m as Metadata).props?.refId];
  return m.map((m) => m.props?.refId).sort();
};

export const getRefIdAndReasonSorted = (m: Metadata[]) => {
  if (!m) return m;
  if (!Array.isArray(m)) return [(m as Metadata).props?.refId];
  return m.map((m) => m.props?.refId + "-" + m.relationship?.props?.reasonId).sort();
};

export const getDataValueByField = (data: Metadata[], field: SchemaField) => {
  if (field?.key == "Item.additionalMandatoryReviewers") {
    return getRefIdAndReasonSorted(data);
  } else {
    return getRefIdSorted(data);
  }
};

export const getDirtyFieldKeys = (
  schema: Schema,
  data: Partial<Metadata>,
  original: Partial<Metadata>,
): Set<string> => {
  const dirty = new Set<string>();
  for (const field of schema?.props?.fields ?? []) {
    let dataValue = data?.props?.[field.field];
    let originalValue = original?.props?.[field.field];
    if (field.fieldType === FieldType.reference) {
      dataValue = getDataValueByField(dataValue, field);
      originalValue = getDataValueByField(originalValue, field);
    }
    if (!deepEquals(dataValue, originalValue) || (dataValue === null && originalValue === 0)) {
      dirty.add(field.field);
    }
  }
  return dirty;
};
